const contactTypeOptions = [
  { label: "Agent (Agency)", value: "Agent (Agency)" },
  { label: "Artist (Artist & Artist Reps)", value: "Artist (Artist & Artist Reps)" },
  { label: "Artist Marketing (Artist & Artist Reps)", value: "Artist Marketing (Artist & Artist Reps)" },
  { label: "Audio / Lighting Vendor (Vendors & Partners)", value: "Audio / Lighting Vendor (Vendors & Partners)" },
  { label: "Backline Vendor (Vendors & Partners)", value: "Backline Vendor (Vendors & Partners)" },
  { label: "Brand Partnerships (Marketing & Media)", value: "Brand Partnerships (Marketing & Media)" },
  { label: "Business Manager (Artist & Artist Reps)", value: "Business Manager (Artist & Artist Reps)" },
  { label: "Digital Marketing (Marketing & Media)", value: "Digital Marketing (Marketing & Media)" },
  { label: "Fan", value: "Fan" },
  { label: "Festival Booker (Promoter & Venue)", value: "Festival Booker (Promoter & Venue)" },
  { label: "FOH Engineer (Tour Ops)", value: "FOH Engineer (Tour Ops)" },
  { label: "Label Marketing (Marketing & Media)", value: "Label Marketing (Marketing & Media)" },
  { label: "Lawyer / Legal (Artist & Artist Reps)", value: "Lawyer / Legal (Artist & Artist Reps)" },
  { label: "Lighting Director (Tour Ops)", value: "Lighting Director (Tour Ops)" },
  { label: "Manager (Artist Management)", value: "Manager (Artist Management)" },
  { label: "Merch Manager (Tour Ops)", value: "Merch Manager (Tour Ops)" },
  { label: "Merchandising (Artist & Artist Reps)", value: "Merchandising (Artist & Artist Reps)" },
  { label: "Merchandising (Promoter & Venue)", value: "Merchandising (Promoter & Venue)" },
  { label: "Merch Vendor (Vendors & Partners)", value: "Merch Vendor (Vendors & Partners)" },
  { label: "Monitor Engineer (Tour Ops)", value: "Monitor Engineer (Tour Ops)" },
  { label: "Other", value: "Other" },
  { label: "Production Manager (Promoter & Venue)", value: "Production Manager (Promoter & Venue)" },
  { label: "Production Manager (Tour Ops)", value: "Production Manager (Tour Ops)" },
  { label: "Promoter (Promoter & Venue)", value: "Promoter (Promoter & Venue)" },
  { label: "Publicist / PR (Marketing & Media)", value: "Publicist / PR (Marketing & Media)" },
  { label: "Sponsorship Partner (Vendors & Partners)", value: "Sponsorship Partner (Vendors & Partners)" },
  { label: "Stage Manager (Tour Ops)", value: "Stage Manager (Tour Ops)" },
  { label: "Talent Buyer (Promoter & Venue)", value: "Talent Buyer (Promoter & Venue)" },
  { label: "Ticketing Partner (Artist & Artist Reps)", value: "Ticketing Partner (Artist & Artist Reps)" },
  { label: "Ticketing Partner (Promoter & Venue)", value: "Ticketing Partner (Promoter & Venue)" },
  { label: "Tour Accountant (Tour Ops)", value: "Tour Accountant (Tour Ops)" },
  { label: "Tour Manager (Artist & Artist Reps)", value: "Tour Manager (Artist & Artist Reps)" },
  { label: "Travel / Logistics (Tour Ops)", value: "Travel / Logistics (Tour Ops)" },
  { label: "Venue (Promoter & Venue)", value: "Venue (Promoter & Venue)" },
  { label: "Venue GM / Operator (Promoter & Venue)", value: "Venue GM / Operator (Promoter & Venue)" },
  { label: "Venue Marketing (Promoter & Venue)", value: "Venue Marketing (Promoter & Venue)" },
];

export default contactTypeOptions;
